import type { PurchaseGoods } from "@zhihaoscm/entity";
import type { GoodsShip } from "@zhihaoscm/entity";

export type PurGoodsRow = Omit<PurchaseGoods, "ships"> & { ship: GoodsShip };
export const flatPurchaseGoods = (purGoodsList: PurchaseGoods[]) => {
    return purGoodsList
        .map(purGoods => {
            return purGoods.ships.map((ship: GoodsShip) => {
                const _purGoods = { ...purGoods } as unknown as PurGoodsRow;
                _purGoods.ship = ship;
                // if (!_purGoods.ship.receiptQuantity) _purGoods.ship.receiptQuantity = _purGoods.ship.ton ?? 1;
                // if (!_purGoods.ship.receiptDate)
                //     _purGoods.ship.receiptDate = dateFormat(dateFormat(new Date(), DATE_PICKER_FORMAT), "YYYY-MM-DD HH:mm:ss");
                // if (!_purGoods.ship.unitPrice) _purGoods.ship.unitPrice = 1;
                return _purGoods;
            });
        })
        .flat();
};
